import Model, { attr, belongsTo } from "@ember-data/model";

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "dmp-health-centre-config": DmpHealthCentreConfig;
  }
}
export default class DmpHealthCentreConfig extends Model {
  @attr("date") declare updatedAt: Date;
  @attr("string") declare pA: string;
  @attr("string") declare pL: string;
  @attr("string") declare pP: string;

  @attr("string") declare ntpAddress: string;
  @attr("number") declare ntpPort: number;
  @attr("boolean") declare isTseEnv: boolean;

  @belongsTo("health-centre", {
    async: false,
    inverse: "dmpHealthCentreConfig"
  })
  healthCentre;

  get proxyAddress(): string {
    return this.pA;
  }

  get proxyLogin(): string {
    return this.pL;
  }

  get proxyPassword(): string {
    return this.pP;
  }
}
